import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=5023c406&scoped=true&"
import script from "./DataBoard.vue?vue&type=script&lang=js&"
export * from "./DataBoard.vue?vue&type=script&lang=js&"
import style0 from "./DataBoard.vue?vue&type=style&index=0&id=5023c406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023c406",
  null
  
)

export default component.exports